import { render } from "./FriendEditView.vue?vue&type=template&id=8ce5db1e"
import script from "./FriendEditView.vue?vue&type=script&lang=js"
export * from "./FriendEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__